export default {
    methods: {
        productUrl(product) {
            if (product && product.url) {
                return product.url;
            }

            if (product && product.slug) {
                return route('products.show', { slug: product.slug });
            }

            return route('products.index');
        },

        hasBaseImage(product) {
            if (!product || !product.base_image) {
                return false;
            }

            return !!(
                product.base_image.path ||
                product.base_image.small ||
                product.base_image.medium ||
                product.base_image.large
            );
        },

        baseImage(product) {
            if (this.hasBaseImage(product)) {
                return (
                    product.base_image.path ||
                    product.base_image.small ||
                    product.base_image.medium ||
                    product.base_image.large
                );
            }

            return `${window.Shop.baseUrl}/themes/storefront/public/images/image-placeholder.png`;
        },
    },
};
